import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { defineComponent, ref, computed, markRaw } from "vue";
import { saveAs } from "@/hooks/downUrl";
import { WarningFilled } from "@element-plus/icons";
export default defineComponent({
  components: {
    WarningFilled: WarningFilled
  },
  props: {
    accept: {
      type: String,
      default: ".png,.zip,.rar,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.bmp"
    },
    limit: {
      type: Number,
      default: 1000000000,
      require: true
    }
  },
  emits: ["update:file", "file"],
  setup: function setup(props, context) {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var fileList = ref([]);

    function request(_x) {
      return _request.apply(this, arguments);
    }

    function _request() {
      _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var formData, _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();
                formData.append("file", val.file);
                _context.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["attachUpload"](formData);

              case 4:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                fileList.value.push({
                  id: data,
                  name: val.file.name
                });
                console.log(fileList);
                upfileList();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _request.apply(this, arguments);
    }

    function handleRemove(val) {
      fileList.value = fileList.value.filter(function (v) {
        return v["id"] !== val.id;
      });
      upfileList();
    }

    function handleProview(val) {
      if (val.id) {
        saveAs(val.id);
      }
    }

    function upfileList() {
      context.emit("file", markRaw(fileList.value));
    } //仅支持上传文字


    var acceptText = computed(function () {
      var arr = props.accept.split(",").map(function (val) {
        return val.slice(1, val.length);
      });
      return arr.join("|");
    }); //上传之前的文件判断

    function beforeAvatarUpload(val) {
      var index = fileList.value.findIndex(function (v) {
        return v.name == val.name;
      });

      if (index > -1) {
        ElMessage.error("该文件已存在于上传列表");
        return false;
      }
    } //文件超出时提醒


    function onExceed() {
      ElMessage.error("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(props.limit, "\u4E2A\u6587\u4EF6"));
    } //编辑回显，重新赋值


    function editFile(value) {
      fileList.value = value;
    }

    return {
      request: request,
      handleRemove: handleRemove,
      handleProview: handleProview,
      acceptText: acceptText,
      beforeAvatarUpload: beforeAvatarUpload,
      onExceed: onExceed,
      editFile: editFile,
      fileList: fileList
    };
  }
});